import { INVALID_EVENT_NAME_REGEX, MAX_EVENT_NAME_LENGTH } from './constants'

export function validateEventName(eventName?: string): string | null {
  if (!eventName) {
    return 'No eventName was defined'
  }

  if (eventName.length > MAX_EVENT_NAME_LENGTH) {
    return `telemetry event name ${eventName} is too long`
  }

  if (eventName.match(INVALID_EVENT_NAME_REGEX)) {
    return `telemetry event name ${eventName} contains an unsupported character`
  }

  return null
}
